async function sendInfo (form) {
    
    const memberRequestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json"},
        body: JSON.stringify({
            FirstName: form.firstname,
            LastName: form.lastname,
            Email: form.email,
            Phone: form.phone,
            City: form.city,
            ApplicationType: "General"
        })
    };

    let result = "";
    
    await fetch("https://api.comsavings.com/originationslite/PersonalMember", memberRequestOptions)
        .then((response) => response.json())
        .then((data) => {
            result = data;
            if(data.code == "SUCCESS") {
                let memberId = data.id;

                const applicationRequestOptions = {
                    method: "POST",
                    headers: { "Content-Type": "application/json"},
                    body: JSON.stringify({
                        ApplicationName: form.firstname + " " + form.lastname + " - Mortgage Application",
                        Comment: form.comment,
                        PersonalId: {"id": memberId},
                        ApplicationTypeId: {"id": "24761000003346136"}
                    })
                };
                fetch("https://api.comsavings.com/originationslite/GeneralApplication", applicationRequestOptions)
                    .then((response) => response.json())    
                    .then((data) => {
                        result = data;
                        if(data.code == "SUCCESS") {
                            return "SUCCESS";
                        } else {
                            throw new Error('Server response wasn\'t OK');
                        }
                    })
                    .catch((error) => {
                        console.error("Error:", error);
                    });
                result = data;    
                return data.code;
            } else {
                throw new Error('Server response wasn\'t OK');
            }
        })
        .catch((error) => {
            console.error("Error:", error);
        });

        return result;
}

export { sendInfo };